import axios from 'axios';

export class GlobalService {
  async updateOrder(ids) {
    const data = {
      ids: ids
    };
    return await axios.post('/api/v1/portal/update-order', data);
  }
  async login(params) {
    return await axios.post('/api/v1/login', params);
  }
  async getOrderInformation(orderId) {
    return await axios.get(`/api/v1/order/${orderId}`);
  }
  async setDestinationAddress(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setReceiverAddress/${orderId}`, data);
  }
  async setOriginAddress(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setOriginAddress/${orderId}`, data);
  }
  async logOut() {
    return await axios.post(`/api/v1/portal/logout`);
  }
  async getDashboardData() {
    return await axios.get(`/api/v1/portal/dashboard`);
  }
  async getNotes(essenceType, essenceId) {
    return await axios.get(`/api/v1/portal/note?type=${essenceType}&id=${essenceId}`);
  }
  async setOrderPackageInfo(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setPackageInfo/${orderId}`, data);
  }
  async changePinStatus(noteId) {
    return await axios.get(`/api/v1/portal/note/changePin/${noteId}`);
  }
  async createNote(data) {
    return await axios.post(`/api/v1/portal/note`, data);
  }
  async editNote(noteId, data) {
    return await axios.put(`/api/v1/portal/note/${noteId}`, data);
  }
  async essenceDelete(essenceType, essenceId) {
    const isEssenceTypeValid = [
      'country',
      'article-category',
      'product-category',
      'city',
      'admin',
      'product-usage',
      'product-type',
      'product-item',
      'color',
      'karat',
      'notification',
      'off-day',
      'brand',
      'article',
      'shipment',
      'warranty',
      'ticket-department',
      'equipment',
      'attachment',
      'wage',
      'discount',
      'product',
      'paymentMethod',
      'giftCard',
      'banner'
    ].includes(essenceType);
    if (!isEssenceTypeValid) throw new Error('Essence type is not valid');
    let url = '';
    switch (essenceType) {
      case 'country':
        url = `/api/v1/portal/country/${essenceId}`;
        break;
      case 'city':
        url = `/api/v1/portal/city/${essenceId}`;
        break;
      case 'admin':
        url = `/api/v1/portal/user/${essenceId}`;
        break;
      case 'product-usage':
        url = `/api/v1/portal/product_usage/${essenceId}`;
        break;
      case 'product-type':
        url = `/api/v1/portal/product_type/${essenceId}`;
        break;
      case 'product-item':
        url = `/api/v1/portal/product-items/${essenceId}`;
        break;
      case 'color':
        url = `/api/v1/portal/color/${essenceId}`;
        break;
      case 'karat':
        url = `/api/v1/portal/karat/${essenceId}`;
        break;
      case 'notification':
        url = `/api/v1/portal/notification/${essenceId}`;
        break;
      case 'off-day':
        url = `/api/v1/portal/off_days/${essenceId}`;
        break;
      case 'brand':
        url = `/api/v1/portal/brand/${essenceId}`;
        break;
      case 'product-category':
        url = `/api/v1/portal/product_category/${essenceId}`;
        break;
      case 'article-category':
        url = `/api/v1/portal/article_category/${essenceId}`;
        break;
      case 'article':
        url = `/api/v1/portal/article/${essenceId}`;
        break;
      case 'banner':
        url = `/api/v1/portal/banner/${essenceId}`;
        break;
      case 'shipment':
        url = `/api/v1/portal/shipment/${essenceId}`;
        break;
      case 'warranty':
        url = `/api/v1/portal/warranty/${essenceId}`;
        break;
      case 'ticket-department':
        url = `/api/v1/portal/ticket_department/${essenceId}`;
        break;
      case 'equipment':
        url = `/api/v1/portal/equipment/${essenceId}`;
        break;
      case 'attachment':
        url = `/api/v1/portal/attachment/${essenceId}`;
        break;
      case 'wage':
        url = `/api/v1/portal/wage/${essenceId}`;
        break;
      case 'discount':
        url = `/api/v1/portal/discount/${essenceId}`;
        break;
      case 'paymentMethod':
        url = `/api/v1/portal/paymentMethod/${essenceId}`;
        break;
      case 'product':
        url = `/api/v1/portal/product/${essenceId}`;
        break;
      case 'giftCard':
        url = `/api/v1/portal/gift-cards/${essenceId}`;
        break;
    }
    return await axios.delete(url);
  }
}

export default GlobalService;
